import {PROD} from "../redux/config";

export const statusesDict = [
    {name: 'UNSUCCESS', code: 'UNSUCCESS'},
    {name: 'SUCCESS', code: 'SUCCESS'},
    {name: 'ACTIVE', code: 'ACTIVE'},
    {name: 'ACTION', code: 'ACTION'},
    {name: 'PROCESSING', code: 'PROCESSING'}
];

export const activeDict = [
    {value: 'Активний', code: "true"},
    {value: 'Неактивний', code: "false"},
];

export const IsInLineCountCallsDict = [
    {value: 'Кількість EWT', code: "true"},
    {value: 'Задана кількість ', code: "false"},
];


export const languages = [
    {name: 'en', id: 'en'},
    {name: 'uk', id: 'uk'},
];

export const voices = [
    {name: 'Жіночий', id: "female"},
    {name: 'Чоловічий', id: "male"},
];

export let isAudio = [
    {name: 'Аудіофайл', state: true},
    {name: 'Диктор', state: false},
];

if (PROD) {
    isAudio = [
        {name: 'Аудіофайл', state: true},
    ];
}

export const weekdayField = [
    {label: 'Пн', dayOfWeek: 1},
    {label: 'Вт', dayOfWeek: 2},
    {label: 'Ср', dayOfWeek: 3},
    {label: 'Чт', dayOfWeek: 4},
    {label: 'Пт', dayOfWeek: 5},
    {label: 'Сб', dayOfWeek: 6},
    {label: 'Нд', dayOfWeek: 0}
];
